




























import { Component, Vue } from "vue-property-decorator";
import { UserType } from "@/types";
import Api from "@/app/api/Api";

@Component
export default class UserForm extends Vue {
  loading = false;
  method: null | "anon" | "google" | "out" = null;

  get user(): UserType {
    return this.$root.$data.user;
  }

  handleAnonymous() {
    this.loading = true;
    this.method = "anon";
    Api.signInAnonymous().then(() => (this.loading = false));
  }

  handleGoogle() {
    this.loading = true;
    this.method = "google";
    Api.signInGoogle();
  }

  handleSignOut() {
    this.loading = true;
    this.method = "out";
    Api.signOut().then(() => (this.loading = false));
  }
}
